import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TimeoutResponse } from '../../shared/types/session';

@Component({
    selector: 'las-timeout-modal',
    templateUrl: './timeout-modal.component.html',
    styleUrls: ['./timeout-modal.component.scss'],
    standalone: false,
})
export class TimeoutModalComponent {
    private _countdown: number = 0;
    @Input() set countdown(countdown: number) {
        this._countdown = countdown;
        this.timeoutMessage = this.getCountdownMessage(countdown);
    }

    get countdown() {
        return this._countdown;
    }

    timeoutMessage = '';

    constructor(
        private dialog: MatDialogRef<TimeoutModalComponent>,
        @Inject(MAT_DIALOG_DATA) public maxCount: number,
    ) {}

    /**
     * Closes the dialog and notifies the parent component the user wants to stay logged in.
     */
    onStayClick = () => this.close(TimeoutResponse.Stay);

    /**
     * Closes the dialog and notifies the parent the user wants to log out.
     */
    onLogoutClick = () => this.close(TimeoutResponse.Logout);

    /**
     * Called by the parent to notify the dialog the user has timed out.
     * Dialog, in turn, closes the dialog and notifies the parent to log the user out.
     */
    onTimeout = () => this.onLogoutClick();

    private close = (result: string) => this.dialog.close(result);

    private getCountdownMessage(countdown: number) {
        const minuteSeconds = 60;
        const message = 'You will be logged out in ';

        let details = '';
        if (countdown < minuteSeconds) {
            details = `${countdown} seconds`;
        } else {
            const minutes = Math.floor(countdown / minuteSeconds);
            const seconds = countdown % minuteSeconds;
            details = this.getMinutesSecondsDetails(minutes, seconds);
        }
        return `${message} ${details}.`;
    }

    private getMinutesSecondsDetails(minutes: number, seconds: number) {
        const pluralize = (n: number) => (n == 1 ? '' : 's');
        const minuteDetails = `${minutes} minute${pluralize(minutes)}`;
        return seconds > 0
            ? `${minuteDetails} and ${seconds} second${pluralize(seconds)}`
            : minuteDetails;
    }
}
